<ng-template let-extraClass="extraClass" #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Upsell Integration'"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container
*ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    <ng-container>
      <div class="info-section">
        <tidy-text [body]="'Connect with our integration partners to automatically manage upsells like early check-in, late checkout, and mid-stay cleaning.'" />
      </div>

      <div class="steps-section">
        <tidy-text [header]="'How to Connect'" />
        <div class="step-list">
          <div class="step-item">
            <span class="step-number">1</span>
            <span>{{ 'Choose an integration partner below' | translate }}</span>
          </div>
          <div class="step-item">
            <span class="step-number">2</span>
            <span>{{ "We'll complete setup within 1 business day" | translate }}</span>
          </div>
          <div class="step-item">
            <span class="step-number">3</span>
            <span>{{ 'Upsell requests are automatically processed' | translate }}</span>
          </div>
        </div>
      </div>

      <div class="partners-section">
        <tidy-text [header]="'Available Partners'" />

        @if (loading) {
          <div class="loading-container">
            <ion-spinner name="crescent" />
          </div>
        }

        @if (!loading) {
          <div class="partners-list">
            @for (partner of upsellPartners; track trackByPartnerId($index, partner)) {
              <div
                class="partner-card"
                (click)="openPartnerIntegration(partner)">
                @if (partner.logo_url) {
                  <img
                    [src]="partner.logo_url"
                    [alt]="partner.name"
                    class="partner-logo">
                }
                <div class="partner-details">
                  <h5 class="partner-name">{{ partner.name }}</h5>
                </div>
              </div>
            }
            @if (upsellPartners.length === 0) {
              <div class="empty-state">
                <p class="empty-message">
                  {{ 'No integration partners are currently available. Please check back later.' | translate }}
                </p>
              </div>
            }
          </div>
        }
      </div>

      <tidy-row [align]="'center'">
        <tidy-button
          [text]="'Got it'"
          [action]="boundClose"
          class="primary" />
      </tidy-row>

      <tidy-error-message [text]="errorMessage" />
    </ng-container>
  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content>
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}